// import defaultSettings from '@/settings'
import store from '@/store'
import i18n from '@/lang'

// const title = defaultSettings.title || '天途航空云控系统'
// const title = store.state.settings.title || '天途航空云控系统'

export default function getPageTitle(key) {
  const title = store.state.user.enterpriseName || '云控系统'
  const hasKey = i18n.te(`route.${key}`)
  if (hasKey) {
    const pageName = i18n.t(`route.${key}`)
    // return `${pageName} - ${title}`
    return `${pageName}`
  }
  return `${title}`
}
